import type { FC } from "react"
import { memo } from "react"

import { useRecoilValue } from "recoil"
import { css } from "styled-components"

import { Dropdown } from "~/components/ui"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"
import { currentUserIsDesignRequestUserState } from "~/containers/Proposal/state/user/user-state"
import { SystemType } from "~/graphql/client"
import { useTriggerPreventionToast } from "~/hooks/useTriggerPreventionToast"
import { getMountTypeLabel } from "~/utils/mount-type"

const MOUNT_OPTIONS: { value: SystemType; label: string }[] = [
  { value: SystemType.roof_mount, label: `Roof` },
  { value: SystemType.ground_mount, label: `Ground` },
  { value: SystemType.both, label: `Both` },
]

const wrapperStyle = css`
  flex-direction: row;
  align-items: center;
  max-width: 200px;
  min-width: fit-content;
  [data-role="dropdown-wrapper"] {
    height: 40px;
  }
`

const MountTypeDropdown_Internal: FC = () => {
  const { remote, updateSystemType, isSaving } = useProposalContext()
  const currentUserIsDesignUser = useRecoilValue(
    currentUserIsDesignRequestUserState,
  )
  const triggerPreventionToast = useTriggerPreventionToast()

  const currentLabel = getMountTypeLabel(remote.systemType)

  const handleSelect = (value: SystemType) => {
    if (!currentUserIsDesignUser) {
      triggerPreventionToast()
      return
    }
    if (value === remote.systemType) return
    void updateSystemType(value)
  }

  return (
    <Dropdown.Container
      wrapperStyle={wrapperStyle}
      SelectedOption={() => <p>Mount: {currentLabel}</p>}
      disabled={isSaving}
      Options={MOUNT_OPTIONS.map((option) => (
        <Dropdown.Item
          key={option.value}
          label1={option.label}
          onClick={() => handleSelect(option.value)}
          isChecked={remote.systemType === option.value}
        />
      ))}
    />
  )
}

export const MountTypeDropdown = memo(MountTypeDropdown_Internal)
